export const getShareText = (
    title: string,
    description: string,
    thoughtText = 'I thought you might like this item on LiveAuctioneers.'
) => {
    const itemDescription =
        description === title || !description
            ? ''
            : `

${description}`;
    const text = `${thoughtText}

${title}${itemDescription}`;

    if (!title && !description) {
        return thoughtText;
    }

    return text;
};
